import script from "./ServicesOurSerSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesOurSerSection.vue?vue&type=script&setup=true&lang=js"

import "./ServicesOurSerSection.vue?vue&type=style&index=0&id=343acc7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-343acc7b"]])

export default __exports__